const getList = {
  nNutritionRawInfoPage:"/nhf-app/factorystaffnutritionraw/selectFactoryStaffNutritionRawInfoWithoutSpecialTypePage",
  factoryRaw: "/nhf-app/factoryRaw/page",
  nutritionPage: "/nhf-app/factorystaffnutritionraw/selectNutritionPage",
  ratioDetailList: "/nhf-app/ratiodetail/list", // 配方表分页
  ratioDetailPage: "/nhf-app/ratiodetail/page", // 配方表分页
  formulaRawNhfDetail: "/nhf-app/formulaSimulation/detail", // 配方详情
  mixDetail: "/nhf-app/formulaextmix/detail", // 配方详情
  formulaModel: "/nhf-nhmodel/formulamodel/UserInfopage", // Hmodel模型
  productionForecast:'/nhf-app/productionforecast/page', // 预计生产量
  factoryList:'/nhf-app/formulaManage/myFactory',
}

const getArrayForm = {
  clearTemp: '/nhf-app/formulaSimulation/clearTemp',
  checkTemp: '/nhf-app/formulaSimulation/checkTemp',
  getNutritionContrast: '/nhf-app/formulaNhf/getNutritionContrast',
  formulaReportUrl: "/nhf-app/formulaNhf/formulaReportUrl",
  formulaMixReportUrl: "/nhf-app/formulaextmix/formulaMixReportUrl", // 混合日粮-  报表路径
  myFormulaNhfPage: "/nhf-app/formulaManage/myFormulaNhfPage", // 配方信息分页查询
  // formulaRawNhfPage: "/nhf-app/formulaNhf/formulaRawNhfPage", // 配方原料分页查询
  mixRawNhfPage: "/nhf-app/formulaNhf/formulaRawNhfPage", // 混合日粮-查看分页查询
  formulaMixRawNhfPage: '/nhf-app/formulaSelfRaw/formulaSelfRawNhfPage', // 日粮分页查询
  // mixBlendPage: 'nhf-app/formulaNhf/formulaNutritionNhfPage', // 补充料分页查询
  formulaNutritionNhfPage: "/nhf-app/formulaNhf/formulaNutritionNhfPage", // 配方营养指标分页查询
  mixNutritionNhfPage: "/nhf-app/formulaNhf/formulaNutritionNhfPage", // 混合日粮查看分-营养指标分页查询
  formulaMixNutritionNhfPage: '/nhf-app/formulaNhf/formulaMixNutritionNhfPage',
  supplementPage: '/nhf-app/formulaNhf/formulaNutritionNhfPage',
  animalTypeList: "/iot-factory/FactoryAnimal/listByParentId", // 动物类型(新)
  nutritionRawPage: "/nhf-app/nutritionMage/nutritionRawPage", // 营养营养指标列表
  factoryRawPage: "/nhf-app/factoryRaw/page", //基础原料列表
  // listByParentId: "/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeId", //基础分类
  listByParentId: "/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit", //基础分类
  myRawPageWithStatus: "/nhf-app/factorystaffraw/myRawPageWithStatus", // 我的原料条件(状态)分页查询
  myRawpage: "/nhf-app/factorystaffraw/myRawpage", // 添加原料的列表
  mixAddRawPage : '/nhf-app/factorystaffraw/selectRawExceptMixPageUp',
  mixAddBlendPage: '/nhf-app/factorystaffraw/myRawpage',
  selectFormulaRawNutritionDetailPage: "/nhf-app/formulaManage/selectFormulaRawNutritionDetailPage", //养分控制-原料
  animalNutritionUserPage:"/nhf-core-data/animalnutrition/animalNutritionUserPage",
  equationList: "/nhf-fine/equation/list", // 方程列表
  listAnimalUserByParentId: "/nhf-core-data/animal/listAnimalUserByParentId",
  nutritionTypeInfoPage: "/nhf-core-data/animalnutritionlink/typeInfoPage",
  selectFormulaMixNutritionToRawPage:"/nhf-app/formulaextmix/selectFormulaMixNutritionToRawPage", // 混合日粮-合计，补充料查询
  linearOptimization: "/nhf-app/formulaRemoteCal/linearOptimization",
  linearOptimizationByOptimization:"/nhf-app/formulaSimulation/linearOptimizationByOptimization",
  mixLinearOptimizationByOptimization:"/nhf-app/formulaRemoteCal/mixLinearOptimizationByOptimization", // 混合日粮-配方优化
  formulaNoticePageList: "/nhf-app/formulanotice/formulaNoticePageList",
  getFormulaHisVersionList: "/nhf-app/formulahis/getFormulaHisVersionList",
  activationFormulaHisVersion: "/nhf-app/formulahis/activationFormulaHisVersion",// 混合日粮切换版本
  activationFormulaMixHisVersion: "/nhf-app/formulaextmixhis/activationFormulaMixHisVersion", // 混合日粮切换版本（新）
  formulataskDetail:'/nhf-app/formulatask/detail',
  selectFormulaTaskFormulaHaveSolutionPage:'/nhf-app/formulataskformula/selectFormulaTaskFormulaHaveSolutionPage',
  copyToTemp: '/nhf-app/formulaSimulation/copyToTemp', // 初始化暂存
  getProductPrice: "/nhf-app/formulaSimulation/getProductPrice",
}

const postArray = {
  saveTempDataToMain: '/nhf-app/formulaSimulation/saveTempDataToMain',
  selectFactoryStaffNutritionRawMoistureVolatilizePage:"/nhf-app/formulaSimulation/rawNutritions",
  selectFormulaNutritionToRawPage:"/nhf-app/formulaSimulation/selectFormulaNutritionToRawPage",
  formulaRawNhfPage: "/nhf-app/formulaSimulation/selectNhfRawPage", // 配方原料分页查询
  formulaNutritionNhfPage: "/nhf-app/formulaSimulation/formulaNutritions", // 配方营养指标分页查询
  nutritionraRemmove: "/nhf-app/factorystaffnutritionraw/remove",
  nutritionraUpdate: "/nhf-app/factorystaffnutritionraw/update",
  ratioDetailSave: "/nhf-app/ratiodetail/save", // 配方表保存
  ratioDetailUpdate: "/nhf-app/ratiodetail/update", // 配方表保存
  ratioDetailSubmit: "/nhf-app/ratiodetail/submit", // 配方表新增
  removeFormulaIds: "/nhf-app/formulaManage/removeFormulaIds", // 批量删除配方
  // removeMix: '/nhf-app/formulaextmix/remove',
  formulaManageSave: "/nhf-app/formulaManage/save",
  formulaBlendSave: "/nhf-app/formulaextmix/save",
  formulaManageUpdate: "/nhf-app/formulaSimulation/updateFormulaTemp", //基础信息编辑
  mixUpdate: "/nhf-app/formulaextmix/update", //基础信息编辑
  updateFormulaMixPrice: '/nhf-app/formulaextmix/updateFormulaMixPrice',// 修改价格计算相关价格
  saveFormulaRawIds: "/nhf-app/formulaSimulation/saveFormulaRawIds", //批量添加原料
  saveMixIds: "/nhf-app/formulaSelfRaw/saveFormulaSelfRawIds", //批量添加日粮
  // saveMixBlendIds: '/nhf-app/formulaManage/saveFormulaRawIds',
  formulaManageRemove: "/nhf-app/formulaSimulation/removeFormulaRawIds", //批量移除配方原料
  mixRemove: '/nhf-app/formulaSelfRaw/remove', //批量移除日粮
  mixBlendRemove: "/nhf-app/formulaManage/remove", //批量移除补充料
  saveFormulaNutritionId: "/nhf-app/formulaManage/saveFormulaNutritionId", // 添加配方营养指标
  saveFormulaMixNutritionId: "/nhf-app/formulaSelfRaw/saveFormulaMixNutritionId", // 应用养分选择表
  resetFormulaRawIds: "/nhf-app/formulaManage/resetFormulaRawIds", // 重置-配方原料
  resetFormulaNutritionIds: "/nhf-app/formulaManage/resetFormulaNutritionIds", //重置-配方营养需要量
  batchSaveRawNutritionIds:"/nhf-app/factorystaffnutritionraw/batchSaveRawNutritionIds",
  removeLogic: "/nhf-app/factorystaffraw/removeLogic",
  formularawUpdate: "/nhf-app/formulaSimulation/updateFormulaRawLimit",
  mixRawUpdate: "/nhf-app/formulaSelfRaw/rawUpdate", // 日粮修改
  formulanutritionUpdate: "/nhf-app/formulaSimulation/updateFormulaNutritionLimit",
  updateMixNutrition: '/nhf-app/formulaSelfRaw/updateMixNutrition', // 合计 - tab合计修改
  singleUpdateStaffNutritionRawListTab: '/nhf-app/formulaSelfRaw/updateMixNutrition',// 合计 - tab合计修改
  mixTotalUpdate: '/nhf-app/formulanutrition/update', // 合计 - 补充料修改
  batchUpdateStaffNutritionRawList:"/nhf-app/formulaSimulation/rawNutritionUpdateResBatch",// 计算应用批量修改
  batchUpdateFormulaRawNutritionList:"/nhf-app/formularawnutrition/batchUpdateFormulaRawNutritionList",
  calculateNutritionraw: "/nhf-app/factorystaffnutritionraw/formulaCalculate",
  formulaEquationCalculateBackGround: "/nhf-app/factorystaffnutritionraw/formulaEquationCalculateBackGround",
  ladderAnalysis: "/nhf-app/formulaRemoteCal/ladderAnalysis",
  confirmCopyFormula: "/nhf-app/formulaManage/confirmCopyFormula",
  confirmCopyFormulaMix: "/nhf-app/formulaManage/confirmCopyFormulaMix", // 混合日粮复制
  rawEquationCalculateBackGround:"/nhf-app/formulaSimulation/rawEquationCalculateBackGround",
  saveFormulaTask: "/nhf-app/formulatask/saveFormulaTask", // 新增多配方任务
  formulataskUpdate: '/nhf-app/formulatask/update',
  updateFactoryStaffRawPrice: '/nhf-app/formulaSimulation/updateFormulaRawPrice',
  updatePriceUrl: '/nhf-app/formulaSimulation/updatePrice', // 修改行价格
  saveAsRawInfo:'/nhf-app/formulaManage/saveAsRawInfo',
  singleUpdateStaffNutritionRawList:'/nhf-app/factorystaffnutritionraw/singleUpdateStaffNutritionRawList',
  singleAutoUpdateStaffNutritionRawList: '/nhf-app/formulaSimulation/rawNutritionUpdateRes',// 计算应用单个修改
  // singleUpdateStaffNutritionRawList: '/nhf-app/factorystaffnutritionraw/singleUpdateStaffNutritionRawList', // 合计 - 合计修改
  updateFormulaFormulaSolutionType: '/nhf-app/formulaManage/updateFormulaFormulaSolutionType',
}

const postFormArray = {
  formulaReportPdf: "/nhf-app/formulaNhf/formulaReportPdf",
  formulaReport: "/nhf-app/formulaNhf/formulaReport",
  removeMix: '/nhf-app/formulaextmix/remove',
  ratioDetailRemove: "/nhf-app/ratiodetail/remove",
  saveProVersion: "/nhf-app/formulaManage/saveProVersion",
  getProductContrast: "/nhf-app/formulahis/getProductContrast",
  getMixProductContrast: "/nhf-app/formulahis/getProductContrast", // 混合日粮-产品对比
  saveFormulaProduct: "/nhf-app/formulahis/saveFormulaProduct",
  saveMixFormulaProduct: "/nhf-app/formulaextmixhis/saveFormulaMixProduct", // 混合日粮-更新版本
  updateFormulaNoticeStatus: "/nhf-app/formulanotice/updateFormulaNoticeStatus",
  linearOptimization: "/nhf-app/formulaRemoteCal/linearOptimization",
  copyFormula: "/nhf-app/formulaManage/copyFormula",
  saveFormulaInfoPro:"/nhf-app/formulaproduct/saveFormulaInfoPro",
  saveMixFormulaInfoPro:"/nhf-app/formulaproduct/saveFormulaMixInfoPro", // 混合日粮-生成产品
  // 验证配方代码是否唯一
  checkFormulaCodeIsUnique:"/nhf-app/formulaManage/checkFormulaCodeIsUnique",
  batchDelFormulaHisVersion: '/nhf-app/formulahis/batchDelFormulaHisVersion',// 版本批量删除
}

const baseApi = (arr, method) => {
  let list = {}
  for (let i in arr) {
    list[i] = async (data) => method(arr[i], data)
  }
  return list
}
import { get, getForm, post, postForm } from "../../Utils/axios"
import { mapState,mapMutations,mapGetters } from 'vuex'

export const nhfMixins = {
  data() {
    return {
      raw: [],
      model: {
        records: [],
      },
      list: {
        records: [],
      },
      price: ["合同价格", "预测价格", "库存价格", "市场价格"],
      rawTypes:[ '所有原料','组分原料','拒绝原料' ],
      rawTypesRadio:[
        { label: '所有原料', value: 0 },
        { label: '组分原料', value: 1 },
        { label: '拒绝原料', value: 2 },
      ],
      priceOption: [
        { label: "合同价格", value: '1' },
        { label: "预测价格", value: '2' },
        { label: "库存价格", value: '3' },
        { label: "市场价格", value: '4' },
      ],
      modelDetail: {},
      nutrition: [],
      modelLoading: false,
      updateLoading: false,
      selectedRowKeys: [],
      selectedRows: [],
      totalPercentage: 0,
      totalCost: 0,
      alertFlag:false,
      pagination: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      factoryId: null,
      bodyStyle: {
        padding: "0 15px 15px",
      },
      modalBodyStyle:{padding:'10px'},
      currentPage: {
        current: 1,
        size: 20,
      },
      modalVisible:false,
      maxLen: 100,
      isFullScreenM: false,
    }
  },
  mounted() {
    this.formulaId = this.$route.query && this.$route.query.id ? this.$route.query.id : null
    this.factoryId = window.localStorage.getItem("factoryId") || null
    document.addEventListener('fullscreenchange',this.logFullScreen)
  },

  computed:{
    ...mapState('nhf',[
      'rawSelect',
      'nutSelect',
      'layout',
      'detail',
      'height',
      'leftBoxTopHeight',// 左上表格高度
      'leftBoxBottomHeight', // 左下表格高度
      'visible',
      'nutRows',
      'rawRows',
      'rawResult',
      'nutVisible',
      'rightWidth',// 可拖拽框右侧宽度
      'leftWidth',// 可拖拽框左侧宽度
      'calculaVisible',
      'rawTableColShow',
      'nutTableColShow',
      'rawTypeSelect',
      'indexFilter',
      'formulaList',
      'rawEditors',
      'rawEditors2',
      'nutritionEditor',
      'nutritions',
      'getVisionRaw',
      'nutritionList'
    ]),
    ...mapGetters('nhf', [
      'nutColumnsValue',
      'rawColumnsValue',
      'rawEditorColumns',
      'rawEditor2Columns',
      'nutritionEditorColumns',
      'nutritionColumns'
    ])
  },

  methods: {
    ...mapMutations('nhf',[
      'setState',
      'toggleLayout',
      'toggleVisible'
    ]),
    ...baseApi(getList, get),
    ...baseApi(getArrayForm, getForm),
    ...baseApi(postArray, post),
    ...baseApi(postFormArray, postForm),

    toggleModalVisible(){
      this.modalVisible = !this.modalVisible
    },
    // normal page
    pageSetting() {
      return {
        size: 20,
        current: 1,
      }
    },

    async fetchGet({ actions, name, data = {}, isList, loading }) {
      if (actions) {
        try {
          if (loading) this[loading] = true

          let params = isList ? { ...this.pageSetting(), ...data } : data
          const res = await actions(params)
          if (name){
            if(name === 'list'){
              this[name] = {records: []}
              this[name] = res.data
            }else{
              if(data.feild === 'animal') {
                res.data.animal = [res.data.animalTypeCode];
                let {formulaExtMix} = res.data || {}
                let {selfProvidedProportion} = formulaExtMix || {}
                res.data.selfProvidedProportion = selfProvidedProportion
              }
              this[name] = res.data
            }
          }
          if (isList) this.setPager(res.data)
          if (!res.success && name) this.$message.warn(res.msg)
          return res
        } catch (error) {
          error.msg && this.$message.warn(error.msg)
        } finally {
          if (loading) this[loading] = false
        }
      }
    },

    async fetchPost({ actions, data, loading, name, showMessage = true }) {
      try {
        if (loading) this[loading] = true
        const res = await actions(data)
        let {success} = res
        if(showMessage && res.msg !== ""){
          this.$message[success ? 'success' : 'warning'](res.msg)
        }
        if (name) this[name] = res.data
        res.data.errorMsg = res.msg
        res.data.code = res.code
        return res.data
      } catch (error) {
        error.msg && this.$message.warn(error.msg)
      } finally {
        if (loading) this[loading] = false
      }
    },

    // 设置分页
    setPager(res) {
      const { total, current, size: pageSize } = res
      this.pagination = {
        ...this.pagination,
        pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
        pageSize,
        total,
        current,
        showSizeChanger: true,
        showTotal: (total) => <div style="flex:1">共{total}条记录</div>,
      }
    },

    cleanSelect() {
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // onSelect(selectedRows) {
    //  this.selectedRows=[...this.selectedRows,...selectedRows]
    // },
    // 全选
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      let arr = [...this.selectedRows, ...selectedRows]
      this.selectedRows = selectedRowKeys.map((i) => {
        return arr.filter((item) => item.id === i)[0]
      })
    },
    // 单选
    onSelect(record, selected){
      if(selected) {
        if(this.selectedRowKeys.length >= this.maxLen){
          this.$message.warning(`选中的原料不能超过${this.maxLen}条`)
        }else{
          if (this.selectedRowKeys.length < this.maxLen &&!this.selectedRowKeys.includes(record.id)) {
            this.selectedRowKeys.push(record.id);
            this.selectedRows.push(record)
          }
        }
      }else{
        this.selectedRowKeys = this.selectedRowKeys.filter(el => el !== record.id)
        this.selectedRows = this.selectedRows.filter(el => el.id !== record.id)
      }
      //计算selectedRows中percentage和price和
      this.totalCost = 0
      this.totalPercentage = 0
      if(this.selectedRows.length>0){
        this.selectedRows.forEach((item)=>{
          if(item.price && item.percentage){
            this.totalCost = this.totalCost + item.price * item.percentage
            this.totalPercentage = this.totalPercentage + item.percentage
          }
        })
        if(this.totalCost!==0) {
          this.totalCost = this.fixedNumber(this.totalCost / 100, 1000)
        }
        if(this.totalPercentage!==0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000)
        }
        this.alertFlag = true
      }
    },
    onSelectAll(selected, selectedRows, changeRows){
      if (selected) {
        if(this.selectedRowKeys.length >= this.maxLen){
          this.selectedRowKeys = [];
          this.selectedRows = []
        }else{
          changeRows.forEach((el) => {
            if (this.selectedRowKeys.length < this.maxLen &&!this.selectedRowKeys.includes(el.id)) {
              this.selectedRowKeys.push(el.id);
              this.selectedRows.push(el)
            }
          });
        }
      } else {
        this.selectedRowKeys = [];
        this.selectedRows = []
      }
      //计算selectedRows中percentage和price和
      this.totalCost = 0
      this.totalPercentage = 0
      if(this.selectedRows.length>0){
        this.selectedRows.forEach((item)=>{
          if(item.price && item.percentage){
            this.totalCost = this.totalCost + item.price * item.percentage
            this.totalPercentage = this.totalPercentage + item.percentage
          }
        })
        if(this.totalCost!==0) {
          this.totalCost = this.fixedNumber(this.totalCost / 100, 1000)
        }
        if(this.totalPercentage!==0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000)
        }
        this.alertFlag = true
      }
    },

    tablePageChange(page) {
      const { current = 1, pageSize: size } = page
      this.currentPage = {
        size,
        current,
      }
      return {
        size,
        current,
      }
    },
    fixedNumber(num, len) {
      return num ? Math.round((num + Number.EPSILON) * len) / len : undefined
    },
    // 乘法
    mul(...val) {
      const strVal = val[0].toString()
      const strValTwo = val[1].toString()
      const index = strVal.indexOf(".")
      const indexTwo = strValTwo.indexOf(".")
      const num = [0, 0]
      if (index > -1) {
        num[0] = strVal.length - 1 - index
      }
      if (indexTwo > -1) {
        num[1] = strValTwo.length - 1 - index
      }
      return (
        Math.round(
          val[0] * Math.pow(10, num[0]) * (val[1] * Math.pow(10, num[1]))
        ) / Math.pow(10, num[0] + num[1])
      )
    },
    // 加法
    add(...val) {
      let max = 0
      let count = 0
      for (let i = 0;i < val.length; i++) {
        const strVal = val[i].toString()
        const index = strVal.indexOf(".")
        let num = 0
        if (index > -1) {
          num = strVal.length - 1 - index
          max = num > max ? num : max
        }
      }
      for (let i = 0; i < val.length; i++) {
        count += Math.round(val[i] * Math.pow(10, max))
      }
      return count / Math.pow(10, max)
    },

    //减法
    sub(arg1,arg2){
      let r1,r2,m,n;
      try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
      try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
      m=Math.pow(10,Math.max(r1,r2));
      n=(r1>=r2)?r1:r2;
      return +((arg1*m-arg2*m)/m).toFixed(n)
    },
    // 除
    div(val, valTwo = 100) {
      const strVal = val.toString()
      const strValTwo = valTwo.toString()
      const index = strVal.indexOf(".")
      const indexTwo = strValTwo.indexOf(".")
      const num = [0, 0]
      if (index > -1) {
        num[0] = strVal.length - 1 - index
      }
      if (indexTwo > -1) {
        num[1] = strValTwo.length - 1 - index
      }
      return (
        Math.round(val * Math.pow(10, num[0])) /
        (Math.round(valTwo * Math.pow(10, num[1])) *
          Math.pow(10, num[0] - num[1]))
      )
    },
    logFullScreen(){
      if(window.document.fullscreenElement){
        this.isFullScreenM = true
      }else{
        this.isFullScreenM = false
      }
    },
    full(){
      let fullScreen = window.document.documentElement
      if(!this.isFullScreenM){
        if(fullScreen.requestFullscreen){
          fullScreen.requestFullscreen()
        }else if(fullScreen.msRequesFullscreen){
          fullScreen.msRequesFullscreen()
        }else if(fullScreen.mozRequesFllscreen){
          fullScreen.mozRequesFllscreen()
        }else if(fullScreen.webkitRequesFullscreen){
          fullScreen.webkitRequesFullscreen()
        }
      }else{
        if(window.document.exitFullscreen){
          window.document.exitFullscreen()
        }else if(window.document.webkitCancelFullscreen){
          window.document.webkitCancelFullscreen()
        }else if(window.document.mozCancelFullscreen){
          window.document.mozCancelFullscreen()
        }else if(window.document.msExitFullscreen){
          window.document.msExitFullscreen()
        }
      }
    }
  },
}
